import createCrudVuexModule from "@/store/crud";

export const managementRoleAccess = createCrudVuexModule({
  namespaced: true,
  path: "/management/role-access",
  actions: {},
});
